import { AccountTreeOutlined } from "@mui/icons-material";
import { Stack, Tooltip } from "@mui/material";
import { COMPETENCIES_IDS_PARAM_NAME } from "constants/global";
import { ConfirmModalContext } from "context/confirmModalContext";
import withAccordion from "hocs/withAccordion";
import AccordionTextFieldControl from "hocs/withAccordion/AccordionTextFieldControl";
import withDraggable from "hocs/withDraggable";
import withSelectionCheckbox, { WithSelectionCheckboxInjectedProps } from "hocs/withSelectionCheckbox";
import { useContext } from "react";
import { FieldArrayWithId, UseFieldArrayRemove, UseFormReturn } from "react-hook-form";
import { CompetencyMapInputs } from "../types";
import Competency from "./Competency";

interface AccordionSummaryTitleProps {
  index: number;
  isEditable: boolean;
}

const AccordionSummaryTitle = ({
  index,
  isEditable,
  selectionCheckboxNode,
}: AccordionSummaryTitleProps & WithSelectionCheckboxInjectedProps) => {
  return (
    <Stack
      direction='row'
      spacing={1}
      alignItems='center'>
      {selectionCheckboxNode}
      <Tooltip title='Компетенция'>
        <AccountTreeOutlined fontSize='small' />
      </Tooltip>
      <AccordionTextFieldControl
        placeholder='Название'
        name={`knowledgeBlocks.${index}.title`}
        disabled={!isEditable}
        disabledViewAsText
      />
    </Stack>
  );
};

const AccordionSummaryTitleWithSelectionCheckbox = withSelectionCheckbox(AccordionSummaryTitle);
const CompetencyWithAccordion = withAccordion(Competency);
const CompetencyWithAccordionWithDraggable = withDraggable(CompetencyWithAccordion);

interface CompetenciesListProps {
  fields: FieldArrayWithId<CompetencyMapInputs, "knowledgeBlocks", "formId">[];
  form: UseFormReturn<CompetencyMapInputs>;
  isEditable: boolean;
  remove: UseFieldArrayRemove;
}

const CompetenciesList = ({ fields, form, isEditable, remove }: CompetenciesListProps) => {
  const { handleOpen } = useContext(ConfirmModalContext);

  const handleRemoveBlock = (index: number) => {
    handleOpen({
      title: "Вы уверены, что хотите удалить компетенцию?",
      handleClick: () => remove(index),
    });
  };

  return (
    <>
      {fields.map((field, index) => (
        <CompetencyWithAccordionWithDraggable
          accordionSummaryTitle={
            <AccordionSummaryTitleWithSelectionCheckbox
              index={index}
              isEditable={isEditable}
              selectionEntity={field.id ? { type: "competency", id: field.id } : undefined}
            />
          }
          key={field.formId}
          draggableId={field.formId}
          index={index}
          isDragDisabled={!isEditable}
          name={`knowledgeBlocks.${index}`}
          onRemove={isEditable ? () => handleRemoveBlock(index) : undefined}
          isEditable={isEditable}
          entityId={field.id}
          idsSearchParamName={COMPETENCIES_IDS_PARAM_NAME}
          sx={{ boxShadow: "0px 0px 7.3px 0px rgba(164, 184, 253, 0.24)" }}
          form={form}
        />
      ))}
    </>
  );
};

export default CompetenciesList;
